import { InputLine } from '@quero-delivery/quero-components-web';
import { Controller, useFormContext } from 'react-hook-form';
import { cpfLabel, yearDateLabel } from '@/Utils/FnUtils';
import styles from './vehicle-data-form.module.scss';
import type { DeliverymanFormType } from '../../types';

function VehicleDataForm() {
  const {
    control,
    formState: { errors },
  } = useFormContext<DeliverymanFormType>();

  return (
    <div className={styles.container}>
      <span className={styles.subtitleForm}>Sobre o veículo</span>

      <div className={styles.form}>
        <div className={styles.twoLines}>
          <div className={styles.lineLeft}>
            <Controller
              control={control}
              name="documentoVeiculo.nomeDonoVeiculo"
              render={({ field: { onChange, value } }) => (
                <InputLine
                  label="Nome registrado"
                  errorMessage={
                    errors.documentoVeiculo?.nomeDonoVeiculo?.message
                  }
                  value={value}
                  onChange={event => onChange(event.target.value)}
                />
              )}
            />
          </div>
          <div className={styles.lineRight}>
            <Controller
              control={control}
              name="documentoVeiculo.cpfDonoVeiculo"
              render={({ field: { onChange, value } }) => (
                <InputLine
                  label="CPF registrado"
                  errorMessage={
                    errors.documentoVeiculo?.cpfDonoVeiculo?.message
                  }
                  value={value}
                  onChange={event => onChange(cpfLabel(event.target.value))}
                />
              )}
            />
          </div>
        </div>
        <div className={styles.twoLines}>
          <div className={styles.lineLeft}>
            <Controller
              control={control}
              name="documentoVeiculo.exercicio"
              render={({ field: { onChange, value } }) => (
                <InputLine
                  label="Exercicio"
                  errorMessage={errors.documentoVeiculo?.exercicio?.message}
                  value={value}
                  onChange={event => onChange(event.target.value)}
                />
              )}
            />
          </div>
          <div className={styles.lineRight}>
            <Controller
              control={control}
              name="documentoVeiculo.renavam"
              render={({ field: { onChange, value } }) => (
                <InputLine
                  label="Renavam"
                  errorMessage={errors.documentoVeiculo?.renavam?.message}
                  value={value}
                  onChange={event => onChange(event.target.value)}
                />
              )}
            />
          </div>
        </div>
        <div className={styles.twoLines}>
          <div className={styles.lineLeft}>
            <Controller
              control={control}
              name="documentoVeiculo.anoFabricacao"
              render={({ field: { onChange, value } }) => (
                <InputLine
                  label="Ano de fabricação (ex: 2010)"
                  errorMessage={errors.documentoVeiculo?.anoFabricacao?.message}
                  value={value}
                  onChange={event =>
                    onChange(yearDateLabel(event.target.value))
                  }
                />
              )}
            />
          </div>
          <div className={styles.lineRight}>
            <Controller
              control={control}
              name="documentoVeiculo.anoModelo"
              render={({ field: { onChange, value } }) => (
                <InputLine
                  label="Ano do modelo (ex: 2010)"
                  errorMessage={errors.documentoVeiculo?.anoModelo?.message}
                  value={value}
                  onChange={event =>
                    onChange(yearDateLabel(event.target.value))
                  }
                />
              )}
            />
          </div>
        </div>
        <div className={styles.twoLines}>
          <div className={styles.lineLeft}>
            <Controller
              control={control}
              name="documentoVeiculo.modelo"
              render={({ field: { onChange, value } }) => (
                <InputLine
                  label="Modelo"
                  errorMessage={errors.documentoVeiculo?.modelo?.message}
                  value={value}
                  onChange={event => onChange(event.target.value)}
                />
              )}
            />
          </div>
          <div className={styles.lineRight}>
            <Controller
              control={control}
              name="documentoVeiculo.chassi"
              render={({ field: { onChange, value } }) => (
                <InputLine
                  label="Chassi"
                  errorMessage={errors.documentoVeiculo?.chassi?.message}
                  value={value}
                  onChange={event => onChange(event.target.value)}
                />
              )}
            />
          </div>
        </div>
        <div className={styles.twoLines}>
          <div className={styles.fullLine}>
            <Controller
              control={control}
              name="documentoVeiculo.placa"
              render={({ field: { onChange, value } }) => (
                <InputLine
                  label="Placa"
                  errorMessage={errors.documentoVeiculo?.placa?.message}
                  value={value}
                  onChange={event => onChange(event.target.value)}
                />
              )}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export { VehicleDataForm };
